module.exports = new __parcel__URL__("list-merge-modal-button-dark.4e0fa33b.png").toString();